import * as React from 'react';
import { Item } from 'Components/Grid';
import HistoryRow from 'Components/HistoryRow';
import HistoryRowControls from 'Components/HistoryRowControls';
import HistoryRowListing from 'Components/HistoryRowListing';
import type { IHistoryContext } from 'Containers/FormContextHandler';
import { formatPartialDate } from 'Utility/date';
import { fm } from 'Components/FormatMessage';
import { newButton } from '../../../../utils/functions';
import { filterDocumentsByType } from 'Utility/documentHandling';
import colors from '../../../../../../config/theme/colors';

const subCategoryDetailsOrder: Array<keyof IPolyneuroEtiologySubCategoryDetails> = [
  'diagnosticCertainty',
  'paraproteinDetected',
  'typeOfParaproteinemia',
  'antiMAGAntibodyDetected',
  'specify',
  'geneticTestResult',
];

const PolyneuroEtiologyHistory = ({
  documents = [],
  startEdit,
}: IHistoryContext<IPolyneuroEtiology>): React.JSX.Element => {
  return (
    <HistoryRow
      headerText={fm('diagnosis.polyneuro.etiology.title')}
      rowButton={
        startEdit ? newButton('polyneuroEtiology', startEdit({}, 'polyneuroEtiology'), 'general.new', 15) : undefined
      }
    >
      <HistoryRowListing
        documents={filterDocumentsByType(documents, ['polyneuroEtiology'])}
        headers={
          <>
            <Item xs={2}>{fm('general.date')}</Item>
            <Item xs={3}>{fm('diagnosis.polyneuro.etiology.mainCategory.title')}</Item>
            <Item xs={3}>{fm('diagnosis.polyneuro.etiology.subCategory.title')}</Item>
            <Item xs={3} />
          </>
        }
        contentFormat={d => {
          return (
            <>
              <Item xs={2} style={{ paddingRight: 0 }}>
                {formatPartialDate(d.date)}
              </Item>
              <Item xs={3}>{fm('diagnosis.polyneuro.etiology.mainCategory.' + d.mainCategory)}</Item>
              <Item xs={3}>{fm('diagnosis.polyneuro.etiology.subCategory.' + d.subCategory)}</Item>
              <Item xs={3}>
                {subCategoryDetailsOrder.map(category => {
                  const data = d.subCategoryDetails?.[category];
                  return data ? (
                    <div key={category} style={{ marginBottom: '1rem' }}>
                      <div style={{ color: colors.darkGray, fontWeight: 400 }}>
                        {fm('diagnosis.polyneuro.etiology.subCategoryDetails.' + category)}
                      </div>
                      {category === 'specify'
                        ? data
                        : data === 'yes' || data === 'no'
                          ? fm('general.' + data)
                          : fm('diagnosis.polyneuro.etiology.opts.' + data)}
                    </div>
                  ) : undefined;
                })}
              </Item>
            </>
          );
        }}
        collapse={false} // All etiologies should be shown NEUR-4608
        makeControls
        historyRowControls={d => (startEdit ? <HistoryRowControls document={d} startEdit={startEdit} /> : <></>)}
      />
    </HistoryRow>
  );
};

export default PolyneuroEtiologyHistory;
